module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Más":"Más","Búsqueda":"Búsqueda"},"en":{},"ca":{"Más":"Més","Búsqueda":"Cerca"}}')
  delete Component.options._Ctor
}
